<template>
  <div style="background: #304156">
    <ElPopover
      v-for="(item, i) in routers"
      :key="item.name"
      :ref="item.name"
      v-model="menuShow[item.name]"
      :popper-class="
        [
          'menu-pop',
          !item.isFlat
            ? `submenu-length-${item.children ? item.children.length : 0}`
            : 'submenu-length-0',
        ].join(' ')
      "
      class="mr10"
      trigger="hover"
      placement="bottom-start"
      :visible-arrow="false"
      :close-delay="50"
    >
      <template #reference>
        <div
          :class="['right-menu right-ce mr10', item.name, { active: menuShow[item.name] }]"
          :style="{
            top: 0,
            left: 100 + 104 * i + 'px',
          }"
          @click="onClickNav(item.name)"
        >
          <span :class="{ selected: item.name === activeMenu }">{{ getTitle(item) }}</span>
        </div>
      </template>
      <ul
        :class="[
          { 'submenu-wrap': !item.isFlat },
          !item.isFlat
            ? `submenu-wrap-length-${item.children ? item.children.length : 0}`
            : 'flat-menu',
        ]"
      >
        <div v-if="item.isFlat">
          <div v-for="child in item.children" :key="child.name" class="lastmenu-wrap">
            <el-link
              :underline="false"
              class="lastmenu-item mr10"
              @click="onMenuSelect(child.path, item.name, getMeta(child).outLink)"
            >
              {{ getTitle(child) }}
            </el-link>
            <span v-if="getMeta(child).isNew" class="new-icon text-12px">NEW</span>
          </div>
        </div>
        <div v-else>
          <li v-for="child in item.children" :key="child.name" class="submenu-item">
            <span class="submenu-title mb10">
              {{ getTitle(child) }}
            </span>
            <div v-if="child.children && child.children.length && !child.onlyOneChild">
              <div v-for="last in child.children" :key="last.name" class="lastmenu-wrap">
                <el-link
                  :underline="false"
                  class="lastmenu-item mr10"
                  @click="onMenuSelect(last.path, item.name, getMeta(last).outLink)"
                >
                  {{ getTitle(last) }}
                </el-link>
                <span v-if="getMeta(last).isNew" class="new-icon text-12px">NEW</span>
              </div>
            </div>
            <div v-else class="lastmenu-wrap">
              <el-link
                :underline="false"
                class="lastmenu-item"
                @click="onMenuSelect(child.path, item.name, getMeta(child.onlyOneChild).outLink)"
              >
                {{ getTitle(child) }}
              </el-link>
            </div>
          </li>
        </div>
      </ul>
    </ElPopover>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import router from '@/router/index.js';
import { ROUTES, TOP_NAV_ACTIVE_SEGMENTS, TOP_NAV_DEFAULT_PATHS } from '@/router/index.js';
import store from '@/store/index.js';
import { isUrl, pathResolve } from '@/components/navTap/constants';

export default {
  setup(_, { refs }) {
    const { getters } = store;
    const hasOneShowingChild = (children = [], parent) => {
      const onlyOneChild = ref();
      const showingChildren = children.filter((v) => {
        if (v?.hidden) {
          return false;
        }
        onlyOneChild.value = v;
        return true;
      });
      if (showingChildren?.length === 1) {
        return {
          oneShowingChild: true,
          onlyOneChild: onlyOneChild.value,
        };
      }
      if (!showingChildren?.length) {
        onlyOneChild.value = { ...parent, path: '', noShowingChildren: true };
        return {
          oneShowingChild: true,
          onlyOneChild: onlyOneChild.value,
        };
      }

      return {
        oneShowingChild: false,
        onlyOneChild: onlyOneChild.value,
      };
    };

    const onMenuSelect = (index, name, outLink) => {
      menuShow.value[name] = false;
      refs[name][0]?.doClose();
      if (isUrl(index)) {
        window.open(index);
      } else if (outLink) {
        window.open(getters.getConfigItem(outLink) + index);
      } else {
        router.push(index);
      }
    };

    const routers = computed(() => {
      const renderMenuItem = (routers, parentPath = '/') =>
        routers
          .map((v) => {
            const meta = v.meta ?? {};
            if (!v?.hidden) {
              const { oneShowingChild, onlyOneChild } = hasOneShowingChild(v.children, v);
              const url = isUrl(v.path) || v?.meta?.outLink ? v.path : false;
              const fullPath = url ? v.path : pathResolve(parentPath, v.path);
              if (
                oneShowingChild &&
                (!onlyOneChild?.children || onlyOneChild?.noShowingChildren) &&
                !meta?.alwaysShow
              ) {
                return {
                  ...v,
                  meta,
                  path: url || (onlyOneChild ? pathResolve(fullPath, onlyOneChild.path) : fullPath),
                  onlyOneChild,
                };
              }
              return {
                ...v,
                path: url || fullPath,
                children: renderMenuItem(v.children, fullPath).filter(
                  (item) => item?.name && !item?.hidden
                ),
              };
            }
            return {};
          })
          .filter((item) => item?.name && !item?.hidden);
      return renderMenuItem(ROUTES ?? []);
    });

    const menuShow = ref({});

    routers.value?.forEach((item) => (menuShow.value[item.name] = false));
    const getTitle = (item) =>
      item.onlyOneChild?.meta?.title ?? item.meta?.title ?? item.title ?? '';

    const getMeta = (item) => {
      const { meta } = item ?? {};
      return meta ?? {};
    };

    const onClickNav = (name) => {
      const defaultPath = TOP_NAV_DEFAULT_PATHS[name] || router.options[name]?.[0]?.path;
      if (defaultPath) {
        router.push(defaultPath);
      }
      refs[name][0]?.doClose();
    };

    return {
      routers,
      getTitle,
      menuShow,
      hasOneShowingChild,
      onMenuSelect,
      getMeta,
      onClickNav,
    };
  },
  data() {
    return {
      activeMenu: '',
    };
  },
  watch: {
    $route: {
      handler() {
        const seg = this.$route.path.split('/')[1] || '';
        this.activeMenu = TOP_NAV_ACTIVE_SEGMENTS[seg] || seg;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.el-menu-demo {
  .el-menu-item {
    height: 50px !important;
    line-height: 50px;
    font-weight: bold;
    font-size: 16px;
  }
}
.flat-menu {
  padding: 5px;
  margin: 0 auto;
}
.right-ce {
  width: 104px;
  text-align: center;
  box-sizing: border-box;
  &.active {
    background-color: rgb(32, 58, 69);
    border-bottom: 4px solid #219aff;
    padding-top: 4px;
  }
  & .selected {
    color: #219aff !important;
  }
  span {
    line-height: 50px;
    font-weight: bold;
    font-size: 16px;
    color: #f4f4f5;
  }
}
.right-menu {
  height: 50px !important;
  width: 104px;
  line-height: 50px;
  font-weight: 700;
  font-size: 16px;
  color: #f4f4f5;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.submenu-wrap {
  column-count: 3;
  column-gap: 10px;
  padding: 10px;
  counter-reset: count;
  margin: 0 auto;
  list-style: none;
  &-length-4 {
    column-count: 4;
  }
  &-length-2 {
    column-count: 2;
  }
  &-length-1 {
    column-count: 1;
  }
}
.submenu-item {
  position: relative;
  break-inside: avoid;
  margin: 0 30px 10px 0;
  color: #219aff;
}
.submenu-title {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  border-bottom: 2px solid #dddddd;
  display: inline-block;
  width: 100%;
}
.lastmenu-item {
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  color: #303133 !important;
}
.lastmenu-wrap {
  overflow: hidden !important;
  display: flex;
  align-items: center;
}
.new-icon {
  color: #ffffff;
  width: 48px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  border-radius: 14px 14px 14px 0;
  background-color: var(--el-color-danger);
}
</style>
<style lang="less">
.el-popper.menu-pop.el-popover {
  background: #ebecf0 !important;
  transform: translate(0, -10px);
  box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.12) !important;
  width: 750px;
  color: #303133;
  &.submenu-length {
    &-0 {
      width: inherit;
      min-width: 104px;
    }
    &-1 {
      width: 250px;
    }
    &-2 {
      width: 500px;
    }
    &-4 {
      width: 1000px;
    }
  }
}
</style>